import * as React from 'react';

import { ModalFrameHeader, ModalFrameMessage } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';
import { CHANNEL_TYPE_INSTAGRAM, CHANNEL_TYPE_TIKTOK } from 'utils/channels';

import './audience-screenshot-feedback-modal.scss';

applyTranslations(require('./audience-screenshot-feedback-modal.i18n.json'));

type Props = {
  channel: string
}

const AudienceScreenshotFeedbackModal = ({ channel }: Props): JSX.Element => {
  const title = __t(`audience_screenshot_feedback_modal.${channel}.title`);
  const message = __t(`audience_screenshot_feedback_modal.${channel}.message`);

  let url = '';
  if (channel === CHANNEL_TYPE_TIKTOK) {
    url = '/static/images/tt-audience-data.png';
  } else if (channel === CHANNEL_TYPE_INSTAGRAM) {
    url = '/static/images/ig-audience-data.png';
  }


  return (
    <section>
      <img
        src={url}
        alt=""
        className="audience-screenshot-feedback-modal"
      />
      <ModalFrameHeader
        title={title}
      />
      <ModalFrameMessage
        message={message}
      />
    </section>
  );
};

export default AudienceScreenshotFeedbackModal;
